import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import find from "lodash/find";
import next from "./../../assets/ic_arrow_right.svg";
import prev from "./../../assets/ic_arrow_left.svg";

const defaultButton = (props) => <button {...props}>{props.children}</button>;

export default class Pagination extends React.Component {
  constructor(props) {
    super(props);

    this.changePage = this.changePage.bind(this);

    this.state = {
      visiblePages: this.getVisiblePages(props.page + 1, props.pages),
    };
  }

  static propTypes = {
    pages: PropTypes.number,
    page: PropTypes.number,
    PageButtonComponent: PropTypes.any,
    onPageChange: PropTypes.func,
    previousText: PropTypes.string,
    nextText: PropTypes.string,
    pageSizeOptions: PropTypes.array,
    onPageSizeChange: PropTypes.func,
    pageSize: PropTypes.number,
    displayRecordCount: PropTypes.object,
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.pages !== nextProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(nextProps.page + 1, nextProps.pages),
        pageSizeOptions: nextProps.pageSizeOptions,
      });
    } else if (this.props.page !== nextProps.page) {
      this.changePage(nextProps.page + 1);
    }
  }

  filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter((page) => page <= totalPages);
  };

  // ✅ Fixed dynamic pagination logic
  getVisiblePages = (page, total) => {
    if (!page) page = 1;

    // For small page counts, show all pages
    if (total <= 6) {
      return this.filterPages([1, 2, 3, 4, 5, 6], total);
    }

    const visiblePages = [];
    const maxVisible = 5; // how many pages to show in the sliding window

    let start = Math.max(page - Math.floor(maxVisible / 2), 1);
    let end = start + maxVisible - 1;

    if (end > total) {
      end = total;
      start = Math.max(end - maxVisible + 1, 1);
    }

    for (let i = start; i <= end; i++) {
      visiblePages.push(i);
    }

    if (visiblePages[0] > 2) {
      visiblePages.unshift("...");
      visiblePages.unshift(1);
    } else if (visiblePages[0] === 2) {
      visiblePages.unshift(1);
    }

    if (visiblePages[visiblePages.length - 1] < total - 1) {
      visiblePages.push("...");
      visiblePages.push(total);
    } else if (visiblePages[visiblePages.length - 1] === total - 1) {
      visiblePages.push(total);
    }

    return visiblePages;
  };

  changePage(page) {
    const activePage = this.props.page + 1;

    if (page === activePage) {
      return;
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages);

    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages),
    });

    this.props.onPageChange(page - 1);
  }

  getSelectedItem = (Options, value) => {
    if (!Options) return;
    const found = find(Options, {
      value: parseInt(value),
    });
    if (found) {
      return found;
    }
    return;
  };

  render() {
    const { PageButtonComponent = defaultButton } = this.props;
    const { visiblePages } = this.state;
    const { pageSizeOptions = [] } = this.props;
    const activePage = this.props.page + 1;
    const { pageSize } = this.props;

    const pageSizeOptionsList = pageSizeOptions.map((x) => ({
      label: x,
      value: x,
    }));

    return (
      <div className="Table__pagination spled-container conv-float-right bottom-pagination">
        {/* Display total count */}
        {this?.props?.displayRecordCount?.displayCount && (
          <span className="total-count-text conv-mr20">
            Total Records :{" "}
            <span style={{ color: "#76287C" }}>
              {this?.props?.displayRecordCount?.count}
            </span>
          </span>
        )}

        {/* Previous Button */}
        <div className="Table__prevPageWrapper">
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              if (activePage === 1) return;
              this.changePage(activePage - 1);
            }}
            disabled={activePage === 1}
          >
            <img
              src={prev}
              alt="prev"
              className={`${
                activePage === 1
                  ? "inactive-prev-pagination"
                  : "active-prev-pagination"
              }`}
            />
          </PageButtonComponent>
        </div>

        {/* Rows Per Page Selector */}
        <span className="notes-trail-content-text conv-mr10 conv-ml10">
          Rows Per Page
        </span>
        <Select
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: "#76287C",
              primary25: "#F4DFF4",
            },
          })}
          className="react-select-container conv-ml10 conv-mr10 conv-width-70p"
          classNamePrefix="react-select"
          options={pageSizeOptionsList}
          onChange={this.props.onPageSizeChange}
          value={this.getSelectedItem(pageSizeOptionsList, pageSize)}
          menuPlacement="top"
        />

        {/* Page Buttons */}
        <div className="Table__visiblePagesWrapper conv-mr10 conv-ml10">
          {visiblePages.map((page, index) => {
            if (page === "...") {
              return (
                <span
                  key={`ellipsis-${index}`}
                  className="Table__ellipsis conv-ml5 conv-mr5"
                >
                  ...
                </span>
              );
            }

            return (
              <PageButtonComponent
                key={page}
                className={
                  activePage === page
                    ? "Table__pageButton Table__pageButton--active"
                    : "Table__pageButton"
                }
                onClick={this.changePage.bind(null, page)}
              >
                {page}
              </PageButtonComponent>
            );
          })}
        </div>
        <div className="Table__nextPageWrapper">
          <PageButtonComponent
            className="Table__pageButton"
            onClick={() => {
              if (activePage === this.props.pages) return;
              this.changePage(activePage + 1);
            }}
            disabled={this.props.pages === 0 || activePage === this.props.pages}
          >
            <img
              src={next}
              alt="next"
              className={`${
                this.props.pages === 0 || activePage === this.props.pages
                  ? "inactive-next-pagination"
                  : "active-next-pagination"
              }`}
            />
          </PageButtonComponent>
        </div>
      </div>
    );
  }
}
